module.exports = {
  loginPrefix: 'login',
};
